import { TriggersConfigMap, TriggerType } from 'sections/onsite-campaigns/types';

export const hasValidTriggers = (triggers?: TriggersConfigMap) => {
  if (!triggers) {
    return false;
  }

  return Object.keys(triggers).some(key => {
    if (key === TriggerType.ExitIntent) {
      return triggers[key]?.active && triggers[key]?.value.length;
    }

    if (key === TriggerType.Inactivity) {
      return triggers[key]?.active && triggers[key]?.value;
    }

    if (key === TriggerType.PageLoad) {
      return triggers[key]?.active && triggers[key]?.value === true;
    }

    if (key === TriggerType.OnClick) {
      return triggers[key]?.active && triggers[key]?.value?.selector;
    }

    return false;
  });
};
